import z from 'zod';

export const CHAT_BASE_PATH = `/chat` as const;
export type ChatBasePath = typeof CHAT_BASE_PATH;
export type ChatSubPath = `${ChatBasePath}/${string}`;
export type ChatPath = ChatBasePath | ChatSubPath;
export const ChatBasePathSchema = z.literal(CHAT_BASE_PATH);

export const isChatPath = (pathname: string): pathname is ChatPath => pathname === CHAT_BASE_PATH || pathname.startsWith(`${CHAT_BASE_PATH}/`);
